import { useAuth } from "@/context/AuthContext";
import ParentHome from "@/pages/parent/ParentHome";
import TeacherHome from "@/pages/teacher/TeacherHome";
import AdminHome from "@/pages/admin/AdminHome";

export default function Home() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "guru") return <TeacherHome />;
  if (user.role === "admin") return <AdminHome />;
  return <ParentHome />;
}
